import React from "react";
import { FaShoppingCart } from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useProductsContext } from "../context/products_context";
import { useCartContext } from "../context/cart_context";

const CartButtons = () => {
  const { closeSidebar } = useProductsContext();
  const { total_items } = useCartContext();
  return (
    <Wrapper className="cart-btn-wrapper">
      <Link to="/cart" className="cart-btn" onClick={closeSidebar}>
        <span className="label">Košík</span>
        <span className="cart-container">
          <FaShoppingCart />
          {total_items > 0 && <span className="cart-value">{total_items}</span>}
        </span>
      </Link>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .cart-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.55rem 1.2rem;
    border: 1px solid rgba(250, 244, 234, 0.45);
    border-radius: var(--radius-pill);
    color: var(--clr-cream);
    font-family: var(--ff-body);
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    transition: var(--transition);
  }
  .cart-btn:hover {
    background: var(--clr-cream);
    border-color: var(--clr-cream);
    color: var(--clr-charcoal-1);
  }

  .cart-container {
    position: relative;
    display: inline-flex;
    align-items: center;
    svg {
      font-size: 1.05rem;
    }
  }
  .cart-value {
    position: absolute;
    top: -12px;
    right: -14px;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    background: var(--clr-accent);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-pill);
    font-size: 0.68rem;
    font-weight: 700;
    color: var(--clr-paper);
    letter-spacing: 0;
  }
`;
export default CartButtons;
